export default "__VITE_ASSET__CvT$V3B8__"